import { bindActionCreators } from '@reduxjs/toolkit';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { trackSoftConversionEvent } from '../../actions/tracking';
import { getItem } from '../../selectors/item';
import { getRetailerAddress } from '../../selectors/retailer';
import { softConversionEvents } from '../../shared/tracking';

const BranchAddress = () => {
  const dispatch = useDispatch();
  const address = useSelector(getRetailerAddress);
  const item = useSelector(getItem);
  const track = bindActionCreators(trackSoftConversionEvent, dispatch);
  const { t } = useTranslation('item');

  if (!address) return null;

  return (
    <li className="detail-list-item">
      <div className="detail-list-item-cell">
        <div className="detail-list-label">{t('Address', { ns: 'item' })}</div>
      </div>
      <div className="detail-list-item-cell">
        <div className="detail-list-value">
          <a
            href={`//maps.google.com/?q=${address}`}
            target="_blank"
            rel="noopener noreferrer"
            title={t('Show address on Google Maps', { ns: 'item' })}
            data-am-link=""
            className="l-block"
            onClick={() =>
              track(item, softConversionEvents.SOFT_CONVERSIONS_ITEM_DEALER_ADDRESS_CLICK)
            }
          >
            {address}
            <i className="icon-link-external m-l-half" />
          </a>
        </div>
      </div>
    </li>
  );
};

export default BranchAddress;
